import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { DataService, environment, MyHttpClientFactory } from '@ups/xplat/core';
import { MaterialVendor } from '../models';

@Injectable({
  providedIn: 'root',
})
export class MaterialVendorService extends DataService<unknown> {
  route: string;

  constructor(httpClient: HttpClient, httpFactory: MyHttpClientFactory) {
    super(
      environment.urls.toolTrackerAPI,
      '/api/materialVendor',
      httpClient,
      httpFactory
    );
  }

  getVendors(): Observable<MaterialVendor[]> {
    return this.httpClient.get<MaterialVendor[]>(`${this.route}`);
  }
}
